import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '🟢',
    title: 'Tomo 1 — ADMISIÓN, DIAGNÓSTICO Y PRIMERAS INTERVENCIONES CLÍNICAS',
    desc: 'Protocolo de admisión · Anamnesis · Consentimiento informado · Screening cognitivo · Primeras 8 sesiones · Perfil Cognitivo Integrado · Devolución diagnóstica · Articulación escolar. Todos los perfiles · Primaria y Secundaria'
  }, {
    icon: '🟡',
    title: 'Tomo 2 — FUNCIONES EJECUTIVAS Y TDAH',
    desc: '20+ actividades de atención sostenida, selectiva y alternante · Memoria de trabajo · Control inhibitorio · Planificación · Orientación a padres · Articulación escolar · Planificador de 12 semanas. Niños 5 a 13 años'
  }, {
    icon: '🟠',
    title: 'Tomo 3 — DISLEXIA Y CONCIENCIA FONOLÓGICA',
    desc: 'Doble ruta lectora · 4 niveles de conciencia fonológica · Decodificación y fluidez · Confusión b/d · Ruta léxica · Comprensión literal e inferencial · Escritura con andamiaje · Planificador de 16 semanas. Niños 5 a 12 años'
  }, {
    icon: '🔴',
    title: 'Tomo 4 — DISCALCULIA Y RAZONAMIENTO LÓGICO-MATEMÁTICO',
    desc: 'Modelo CRA completo · Sentido numérico · Línea numérica mental · 4 operaciones con material concreto · Valor posicional · Resolución de problemas · Ansiedad matemática · Planificador de 14 semanas. Niños 6 a 12 años'
  }, {
    icon: '🟣',
    title: 'Tomo 5 — CLÍNICA DE EMOCIONES Y VÍNCULOS',
    desc: 'Neurociencia afectiva · Autopercepción académica · Vocabulario emocional · Termómetro emocional · Regulación emocional · Teoría de la Mente · Habilidades sociales · Comunicación asertiva · Planificador de 14 semanas. Niños 5 a 13 años'
  }, {
    icon: '⭐',
    title: 'Tomo 6 — ADOLESCENCIA Y ORIENTACIÓN VOCACIONAL',
    desc: 'Cerebro adolescente · Vínculo terapéutico · Métodos de estudio (Cornell, Pomodoro, PQ4R) · Comprensión lectora académica · Escritura argumentativa · Procrastinación · OVO informal · Planificador de 16 semanas. Adolescentes 12 a 18 años'
  }];
  const includes = ['Planificación mensual y trimestral lista para usar', '30-50 actividades clínicas con objetivo, consigna y registro', 'Protocolos de evaluación con fichas de seguimiento', 'Plantillas de informe listas para completar', 'Materiales imprimibles para usar directamente en sesión', '100% adaptado a la psicopedagoga argentina'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-258">
      <div className="max-w-6xl mx-auto" data-id="element-259">
        <div className="text-center mb-12" data-id="element-260">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-261">
            <Book className="w-5 h-5" data-id="element-262" />
            <span data-id="element-263">EL SISTEMA</span>
          </div>
          <h2 className="md:text-5xl font-black mb-4 text-[28px]" data-id="element-264">
            ULTRAPACK PSICOPEDAGÓGICO PRO™
          </h2>
          <p className="text-xl text-gray-400" data-id="element-265">
            6 Tomos + 6 Bonos — Todas las áreas — Todo resuelto
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-266">
            +480 páginas · 200+ actividades clínicas listas · Evaluaciones ·
            Informes · Protocolos · Derivaciones · Tareas · Gestión ·
            Posicionamiento · Negocio.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-267">
          {['Diagnóstico', 'Planificación', 'Lectoescritura', 'Matemática', 'Emociones', 'Adolescencia', 'Informes y OS', 'Sesiones', 'Fonología', 'Discalculia', 'Vínculos', 'OVO'].map((tag, i) => <div key={i} className="bg-dark-card border border-dark-border px-2.5 py-1 rounded-full text-xs text-gray-300 font-medium" data-id="element-268">
              {tag}
            </div>)}
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center mt-[-30px]" data-id="element-269">
          📚 LOS 6 TOMOS — Para Psicopedagogas de todas las áreas clínicas
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-270">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-271">
              <div className="text-2xl mb-3" data-id="element-272">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-273">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-274">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto mt-[-25px] pt-[15px] pb-[15px] pl-[15px] pr-[15px] space-x-[12px] space-y-[16px]" data-id="element-275">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-276">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-277">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-278">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-279" />
                <span className="text-gray-300 text-[16px]" data-id="element-280">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}